import { PUBLIC_ROUTES } from './routes';

/**
 * Where "View refund policy" on the refund dialog points.
 *
 * The money-back guarantee is Section 5 of the Terms of Use. That document's
 * headings carry no anchors, so the link opens the document itself — which is
 * also what the package card's policy note links to, so both say the same
 * thing about where the policy lives.
 */
export const BILLING_REFUND_POLICY_HREF: string = PUBLIC_ROUTES.TERMS_OF_USE;
